var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.links),function(ref){
var name = ref.name;
var icon = ref.icon;
var link = ref.link;
return _c('v-col',{key:icon,staticClass:"link",attrs:{"cols":"4"}},[_c('a',{attrs:{"href":link}},[_c('div',{staticClass:"icon"},[_c('v-icon',{attrs:{"color":_vm.brand.colors.usefulLinksIcon,"size":_vm.$vuetify.breakpoint.smAndDown ? 20 : 35}},[_vm._v(_vm._s(icon))])],1),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(name)+" ")])])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }